import { Check, Globe } from "lucide-react";
import { useTranslation } from "react-i18next";

import { Button } from "@profitlens/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuTrigger,
} from "@profitlens/ui/dropdown-menu";
import { LANGUAGES } from "@/i18n";

/** 语言切换；选择结果由 i18next 持久化（localStorage `pl.admin.locale`）。 */
export function LanguageSwitcher({ compact = false }: { compact?: boolean }) {
  const { t, i18n } = useTranslation();
  const current = i18n.resolvedLanguage ?? i18n.language;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size={compact ? "icon" : "sm"} aria-label={t("common.language")}>
          <Globe className="h-4 w-4" />
          {compact ? null : <span className="hidden sm:inline">{t("common.language")}</span>}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuLabel>{t("common.language")}</DropdownMenuLabel>
        {LANGUAGES.map((language) => (
          <DropdownMenuItem
            key={language.code}
            onSelect={() => void i18n.changeLanguage(language.code)}
            className="justify-between"
          >
            <span>{language.label}</span>
            {current === language.code ? <Check className="h-4 w-4 text-brand" /> : null}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
